import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import styles from './analysisHostory.module.scss';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import useLocalStorage from 'src/components/hooks/useLocalStorage.js';
import {
  Body,
  SecondaryText,
} from 'src/components/landingComponents/typography';

export const analysisHistoryKey = 'analysisHistory';

export default function AnalysisHostory({ space, onHistoryElementClick }) {
  const history = useNavigate();
  const { get, patch } = useLocalStorage();
  const [analysisHistory, setAnalysisHistory] = useState(
    get(analysisHistoryKey) || []
  );

  const viewData = Object.entries(analysisHistory)
    .filter((i) => !!space ? i?.[1]?.space === space : true)
    .map((i) => ({
      guid: i[0],
      ...i[1],
    }));

  if (!viewData?.length) {
    return null;
  }

  const onRowClick = (guid) => {
    onHistoryElementClick?.(guid)
  }

  const onDelete = (event, guid) => {
    event.preventDefault();
    event.stopPropagation();

    const currentHistory = get(analysisHistoryKey);
    const withoutDeletedItem = Object.entries(currentHistory).filter(
      (i) => i?.[0] !== guid
    );

    setAnalysisHistory(Object.fromEntries(withoutDeletedItem));
    patch(analysisHistoryKey, Object.fromEntries(withoutDeletedItem));
  };

  return (
    <Paper className={styles.container}>
      <Body>Выберите из последних 10 запросов или заполните поле "Код запроса" вручную</Body>
      {/* <Typography variant="body" gutterBottom>
        
      </Typography> */}
      <div className={styles.historyTable}>
        {viewData.map((i) => {
          return (
            <div key={i.guid} className={styles.historyRow} onClick={() => onRowClick(i.guid)}>
              <SecondaryText className={styles.guid} extraSmall>{i.guid}</SecondaryText>
              <div className={styles.timeBlock}>
                <Body className={styles.time}>{i.time}</Body>
                <IconButton
                  aria-label="delete"
                  onClick={(event) => onDelete(event, i.guid)}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>
    </Paper>
  );
}
